export default __webpack_public_path__ + "static/media/KonfhubWhiteLogo.b18d88eb.svg";